module.exports = __webpack_public_path__ + "static/img/team-technology.d0ec637e.png";